import { AiInterviewType, InterviewDifficulty, InterviewStage, Recommendation } from '../../types';

export const INTERVIEW_TYPE_META: Record<AiInterviewType, { label: string; badge: string }> = {
  TECHNICAL: { label: 'Technical', badge: 'bg-violet-50 text-violet-700' },
  BEHAVIORAL: { label: 'Behavioral', badge: 'bg-sky-50 text-sky-700' },
  GENERAL: { label: 'General', badge: 'bg-zinc-100 text-zinc-700' },
  HR_SCREENING: { label: 'HR screening', badge: 'bg-emerald-50 text-emerald-700' },
  CUSTOM: { label: 'Custom', badge: 'bg-amber-50 text-amber-700' },
};

export const INTERVIEW_TYPE_ORDER: AiInterviewType[] = ['TECHNICAL', 'BEHAVIORAL', 'GENERAL', 'HR_SCREENING', 'CUSTOM'];

export const INTERVIEW_DIFFICULTY_META: Record<InterviewDifficulty, { label: string; badge: string }> = {
  JUNIOR: { label: 'Junior', badge: 'bg-emerald-50 text-emerald-700' },
  MID_LEVEL: { label: 'Mid-level', badge: 'bg-sky-50 text-sky-700' },
  SENIOR: { label: 'Senior', badge: 'bg-violet-50 text-violet-700' },
};

export const INTERVIEW_DIFFICULTY_ORDER: InterviewDifficulty[] = ['JUNIOR', 'MID_LEVEL', 'SENIOR'];

export const RECOMMENDATION_META: Record<Recommendation, { label: string; badge: string }> = {
  STRONG_MATCH: { label: 'Strong match', badge: 'bg-emerald-100 text-emerald-800' },
  MATCH: { label: 'Match', badge: 'bg-emerald-50 text-emerald-700' },
  PARTIAL_MATCH: { label: 'Partial match', badge: 'bg-amber-50 text-amber-700' },
  NO_MATCH: { label: 'No match', badge: 'bg-red-50 text-red-600' },
};

export const STAGE_META: Record<InterviewStage, { label: string; dot: string; hint: string }> = {
  IDLE: { label: 'Ready', dot: 'bg-zinc-300', hint: '' },
  CONNECTING: { label: 'Connecting…', dot: 'bg-brand-500 animate-pulse', hint: 'Starting the voice session.' },
  INTRO: { label: 'Introduction', dot: 'bg-brand-500', hint: '' },
  ASKING: { label: 'Interviewer speaking', dot: 'bg-violet-500', hint: '' },
  LISTENING: { label: 'Listening…', dot: 'bg-emerald-500 animate-pulse', hint: 'Speak now.' },
  PROCESSING: { label: 'Processing…', dot: 'bg-amber-500 animate-pulse', hint: '' },
  COMPLETING: { label: 'Wrapping up…', dot: 'bg-brand-500 animate-pulse', hint: 'Generating your evaluation.' },
  COMPLETED: { label: 'Completed', dot: 'bg-emerald-500', hint: '' },
  ERROR: { label: 'Interrupted', dot: 'bg-red-500', hint: '' },
};